// extracted by mini-css-extract-plugin
export var allButton = "cookieBanner-module--allButton--2d29a";
export var button = "cookieBanner-module--button--42491";
export var buttonContainer = "cookieBanner-module--buttonContainer--ae6c6";
export var checkbox = "cookieBanner-module--checkbox--a220d";
export var checkboxLabel = "cookieBanner-module--checkboxLabel--7c3ee";
export var checkboxWrapper = "cookieBanner-module--checkboxWrapper--56cf4";
export var cookieBanner = "cookieBanner-module--cookieBanner--08816";
export var cookieBannerInner = "cookieBanner-module--cookieBannerInner--ec460";
export var formWrapper = "cookieBanner-module--formWrapper--ce351";
export var headline = "cookieBanner-module--headline--b73e8";
export var selectionButton = "cookieBanner-module--selectionButton--04a6d";
export var slider = "cookieBanner-module--slider--d000d";
export var text = "cookieBanner-module--text--f2d71";